import { MapTo } from '@adobe/aem-react-editable-components';
import { default as NextApplicationCta, ApplicationCtaEditConfig } from './ApplicationCta-RefactoredValidations';
import { default as PrevApplicationCta } from './ApplicationCta';

const useNewApplicationCta = JSON.parse(document.querySelector('meta[property="featureFlagsProvider"]')?.content || '{}')['DPM-12192-ApplicationCtaValidationsRefactor'] === true

const ApplicationCtaSwitch = (props) => {
    return (useNewApplicationCta ? NextApplicationCta : PrevApplicationCta).call(this, props);
}
export default MapTo('cob-corp-acquisition/components/creditonebank/application-cta')(ApplicationCtaSwitch, ApplicationCtaEditConfig);